import { Animations } from '../Animations';
import { AnimationsProps } from '../Animations.types';
import cardsLoading from './cards_loading.json';

export const CardsLoading: React.FC<Omit<AnimationsProps, 'animation'>> = (props) => (
  <Animations animation={cardsLoading} width={200} {...props} />
);
